import { Typography } from "@mui/material"

export function ScenarioHeaderLabel({ children, align }) {
    return (
        <Typography variant="subtitle2" color="text.secondary" align={align}>
            {children}
        </Typography>
    )
}
